import { useState } from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import { useRillContext } from "../../../rill/RillReact/share/base";
import { getCheckInSchedule } from "../../../utils/questionnaire";
import { validateSchedule } from "../../../utils/questionnaire-validations";
import Modal from "../../modal-new";
import QuestionnaireScheduleFields from "./QuestionnaireScheduleFields";

const QuestionnaireSchedule = ({
  startingCalendarDay,
  athlete,
  userToLoadInformation,
}) => {
  const { t } = useTranslation("coaching-portal");
  const { locals } = useRillContext();

  const { _id: athleteId } = athlete;
  const schedule = getCheckInSchedule(athlete);
  const { assert, flash } = locals;

  const [currentSchedule, setCurrentSchedule] = useState(
    schedule
      ? {
          dayOfWeek: schedule.dayOfWeek,
          startDay: schedule.startDay,
          frequency: schedule.frequency,
          selectedWeeklyDays: schedule.selectedWeeklyDays,
        }
      : { dayOfWeek: "", startDay: 0, frequency: "", selectedWeeklyDays: [] }
  );

  const handleSetSchedule = () => {
    if (validateSchedule(currentSchedule, assert, flash)) {
      submit("/actions/questionnaire/add-schedule", {
        method: "POST",
        body: {
          schedule: currentSchedule,
          athleteId,
          userToRequest: userToLoadInformation._id,
        },
      });
    }
  };

  return (
    <Modal
      width={"45%"}
      title={t("questionnaireSchedule.title")}
      className={"questionnaire-schedule-modal"}
    >
      <div className="body">
        <QuestionnaireScheduleFields
          startingCalendarDay={startingCalendarDay}
          initialSchedule={schedule || null}
          onChange={setCurrentSchedule}
        />
      </div>
      <footer>
        <a
          href="/actions/refresh?modal=&undefined="
          role="button"
          data-button-type="secondary"
          data-action="cancel"
        >
          {t("common:cancel")}
        </a>
        <button
          onClick={handleSetSchedule}
          data-button-type="primary"
          type="button"
        >
          {t("common:save")}
        </button>
      </footer>
    </Modal>
  );
};

export default QuestionnaireSchedule;
